import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

export const unauthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.vigilantApiUrl)) return next(req);

  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        snackBar.open('Session expired — please log in again.', undefined, { duration: 5000 });
        router.navigateByUrl('/login');
      }
      return throwError(() => err);
    })
  );
};
